/**
 * Sound and vibration for a scan outcome. A worker in ear defenders on a loud dock reads the
 * phone; a worker with the phone in a pocket feels it. Both are best-effort: a browser that
 * blocks audio until a gesture, or a device with no vibration motor, simply gets nothing.
 *
 * Called for every scan outcome the worker is shown, and by the queue when a scan they have
 * already walked away from comes back refused (§10.4).
 */
let ctx: AudioContext | null = null;

function beep(freq: number, ms: number, at = 0): void {
  try {
    ctx ??= new AudioContext();
    // A context created before the worker has touched the page starts suspended, which would
    // silence the first scan of a shift. Resuming is a no-op once it is already running.
    if (ctx.state === 'suspended') void ctx.resume().catch(() => undefined);
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = freq;
    o.type = 'square';
    g.gain.value = 0.06;
    o.connect(g).connect(ctx.destination);
    const start = ctx.currentTime + at / 1000;
    o.start(start);
    o.stop(start + ms / 1000);
  } catch {
    /* no audio */
  }
}

export function feedback(kind: 'ok' | 'warn' | 'bad'): void {
  if (kind === 'ok') beep(880, 90);
  if (kind === 'warn') {
    beep(520, 80);
    beep(520, 80, 140);
  }
  if (kind === 'bad') beep(220, 450);
  const pattern = kind === 'ok' ? 40 : kind === 'warn' ? [60, 60, 60] : [200, 80, 200];
  try {
    navigator.vibrate?.(pattern);
  } catch {
    /* no vibration */
  }
}
